import { Component, OnInit, ViewChild, AfterViewInit, Inject } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { isMobile, isMobileXL, loadData } from 'src/app/shared/utils/helpers';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Producto } from 'src/app/shared/models/producto';
import { ProductosService } from 'src/app/shared/services/productos.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { TablasService } from 'src/app/shared/services/tablas.service';
import { CuentasService } from 'src/app/shared/services/cuentas.service';
import { Cuenta } from 'src/app/shared/models/cuenta';
import { forkJoin } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { Direccion } from 'src/app/shared/models/direccion';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { CuentaDistribuidor } from 'src/app/shared/models/cuentaDistribuidor';
import { CuentasDistribuidoresDialogComponent } from './cuentas-distribuidores-dialog.component';
import { DireccionesDialogComponent } from './direcciones-dialog.component';

@Component({
  selector: 'app-cuentas-dialog',
  templateUrl: './cuentas-dialog.component.html'
})
export class CuentasDialogComponent implements OnInit, AfterViewInit {

  mensaje: number = 0;
  form: FormGroup;
  idTipo: number;
  c: Cuenta;
  codigoEdit: number = -1;



  @ViewChild('matPaginatorCuentasDistribuidores') matPaginatorCuentasDistribuidores: MatPaginator;
  @ViewChild('matPaginatorDirecciones') matPaginatorDirecciones: MatPaginator;
  @ViewChild('matSortCuentasDistribuidores') matSortCuentasDistribuidores: MatSort;
  @ViewChild('matSortDirecciones') matSortDirecciones: MatSort;
  dataSourceDirecciones = new MatTableDataSource<Direccion>();
  dataSourceCuentasDistribuidores = new MatTableDataSource<CuentaDistribuidor>();
  displayedColumnsDirecciones = ['acciones','idPais', 'provincia', 'ciudad', 'calleNro', 'codigoPostal', 'direccionEnvio', 'direccionFacturacion', 'nroClientePartner', 'funcionPartner', 'codigoCoagra','status'];
  displayedColumnsCuentasDistribuidores = ['acciones', 'nroClienteCuenta', 'nombre', 'ciudad', 'calleNro', 'nroClienteDistribuidor', 'codigoBodegaCoagra','codigoBodegaMyV'];


  constructor(
    private configService: ConfigService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<CuentasDialogComponent>,
    private fb: FormBuilder,
    private loggedService: LoggedService,
    private productosService: ProductosService,
    private cuentasService: CuentasService,
    private snackBarService: SnackbarService,
    private tablasService: TablasService,

    @Inject(MAT_DIALOG_DATA) private data: any) {
    this.form = this.fb.group({

      calleNro: [''],
      ciudad: [''],
      codigoPostal: [''],
      creditoUtilizado: [0],
      cuit: [''],
      fechaVtoCredito: [''],
      idDivision: [''],
      idMoneda: [''],
      idTipoCliente: [''],
      idCondicionPago: [''],
      idTipoCredito: [''],
      tipoCredito: [''],
      grupoCliente: [''],
      condicionPago: [''],
      idRegion: [''],
      idZonaVendedor: [''],
      zonaVendedor: [''],
      limiteCredito: [0],
      nombre: [''],
      nroCliente: [''],
      provincia: [''],
      sitioInternet: [''],
      status: [''],
      taxClassification: [''],
      telefono: [''],
      usuarioRedUltimaActualizacion: [''],
      codigo: [0],
      email:['', Validators.email],
      emailOpcional:['', Validators.email],
      idSalesOffice: [''],
    })

    if (data.idTipo != null) {
      this.idTipo = data.idTipo;
    }
    if (data.c != null) {
      this.codigoEdit = data.c.codigo
      this.c = data.c

    }
  }

  public Tooltips: {
    Editar: string
  }
  public Etiquetas: {
    Acciones: string,
    Bloqueo: string,
    Buscar: string,
    CalleNro: string,
    Ciudad: string,
    CodigoPostal: string,
    CreditoUtilizado: string,
    Cuit: string,
    DBEKR: string,
    DireccionEnvio: string,
    DireccionFacturacion: string,
    FechaVtoCredito: string,
    IdCondicionPago: string;
    IdDivision: string,
    IdGrupoCliente: string,
    IdMoneda: string,
    IdRegion: string,
    IdTaxClassification: string,
    IdTipoCliente: string,
    IdTipoCredito: string,
    IdZonaVendedor: string,
    LimiteCredito: string,
    Nombre: string,
    NroCliente: string,
    NroClientePartner: string,
    Pais: string,
    Provincia: string,
    Region: string,
    SinRegistros: string;
    SitioInternet: string,
    Status: string,
    Telefono: string,
    FuncionPartner: string,
    Email: string
    EmailOpcional: string
    SalesOffice: string
    CodigoBodegaMyV: string
    CodigoBodegaCoagra: string
  }

  ngAfterViewInit() {
    this.dataSourceDirecciones.paginator = this.matPaginatorDirecciones;
    this.dataSourceDirecciones.sort = this.matSortDirecciones;
    this.dataSourceDirecciones.sort.disableClear = true;

    this.dataSourceCuentasDistribuidores.paginator = this.matPaginatorCuentasDistribuidores;
    this.dataSourceCuentasDistribuidores.sort = this.matSortCuentasDistribuidores;
    this.dataSourceCuentasDistribuidores.sort.disableClear = true;
  }

  ngOnInit() {
    this.dialogRef.beforeClosed().subscribe(() => this.dialogRef.close(this.mensaje));
    this.Tooltips = {
      Editar: this.configService.tooltips.Editar,

    }
    this.Etiquetas = {
      Acciones: this.configService.etiquetas.Acciones,
      Bloqueo: this.configService.etiquetas.Cuentas.Bloqueo,
      Buscar: this.configService.etiquetas.Buscar,
      CalleNro: this.configService.etiquetas.Cuentas.CalleNro,
      Ciudad: this.configService.etiquetas.Cuentas.Ciudad,
      CodigoPostal: this.configService.etiquetas.Cuentas.CodigoPostal,
      CreditoUtilizado: this.configService.etiquetas.Cuentas.CreditoUtilizado,
      Cuit: this.configService.etiquetas.Cuentas.Cuit,
      DBEKR: this.configService.etiquetas.Cuentas.DBEKR,
      DireccionEnvio: this.configService.etiquetas.Cuentas.DireccionEnvio,
      DireccionFacturacion: this.configService.etiquetas.Cuentas.DireccionFacturacion,
      FechaVtoCredito: this.configService.etiquetas.Cuentas.FechaVtoCredito,
      FuncionPartner: this.configService.etiquetas.Cuentas.FuncionPartner,
      IdCondicionPago: this.configService.etiquetas.Cuentas.IdCondicionPago,
      IdDivision: this.configService.etiquetas.Cuentas.IdDivision,
      IdGrupoCliente: this.configService.etiquetas.Cuentas.IdGrupoCliente,
      IdMoneda: this.configService.etiquetas.Cuentas.IdMoneda,
      IdRegion: this.configService.etiquetas.Cuentas.IdRegion,
      IdTaxClassification: this.configService.etiquetas.IdTaxClassification,
      IdTipoCliente: this.configService.etiquetas.Cuentas.IdTipoCliente,
      IdTipoCredito: this.configService.etiquetas.Cuentas.IdTipoCredito,
      IdZonaVendedor: this.configService.etiquetas.Cuentas.IdZonaVendedor,
      LimiteCredito: this.configService.etiquetas.Cuentas.LimiteCredito,
      Nombre: this.configService.etiquetas.Cuentas.Nombre,
      NroCliente: this.configService.etiquetas.Cuentas.NroCliente,
      NroClientePartner: this.configService.etiquetas.Cuentas.NroClientePartner,
      Pais: this.configService.etiquetas.IdPais,
      Provincia: this.configService.etiquetas.Cuentas.Provincia,
      Region: this.configService.etiquetas.Cuentas.Region,
      SinRegistros: this.configService.etiquetas.SinRegistros,
      SitioInternet: this.configService.etiquetas.Cuentas.SitioInternet,
      Status: this.configService.etiquetas.Cuentas.Status,
      Telefono: this.configService.etiquetas.Cuentas.Telefono,
      Email: this.configService.etiquetas.Cuentas.Email,
      EmailOpcional: this.configService.etiquetas.EmailOpcional,
      SalesOffice: this.configService.etiquetas.SalesOffice,
      CodigoBodegaMyV: this.configService.etiquetas.CodigoBodegaMyV,
      CodigoBodegaCoagra: this.configService.etiquetas.CodigoBodegaCoagra
    }
    if (typeof this.c != 'undefined') {
      if (this.codigoEdit != -1) {
        forkJoin([

          this.cuentasService.cCuentaDb(this.codigoEdit),
          this.cuentasService.cDirecciones(this.c.idPais, this.c.idCompania, this.c.idSalesOrg, this.c.nroCliente),
          this.cuentasService.cCuentasDistribuidores(this.c.idPais, this.c.idCompania, this.c.idSalesOrg, this.c.nroCliente)

        ]).subscribe((data: [Cuenta, Direccion[], CuentaDistribuidor[]]) => {



          if (data[0] != null) {
          
            loadData(this.form, data[0])
          }
          if (data[1] != null) {
            this.dataSourceDirecciones.data = [];
            this.dataSourceDirecciones.data = data[1];
          }
          if (data[2] != null) {
            this.dataSourceCuentasDistribuidores.data = [];
            this.dataSourceCuentasDistribuidores.data = data[2];
          }
        }


        );
      }
    }

  }

  guardarCuenta() {



    switch (this.idTipo) {

      case 2:
        this.form.controls['usuarioRedUltimaActualizacion'].setValue(this.loggedService.logged.userName);
        this.cuentasService
          .mCuenta(this.form.value)
          .subscribe((data: boolean) => {
            this.mensaje = this.idTipo;
            this.dialogRef.close();
          });
        break;
    }

  }


  applyFilterDirecciones(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceDirecciones.filter = filterValue.trim().toLowerCase();
  }

  applyFilterCuentasDistribuidores(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceCuentasDistribuidores.filter = filterValue.trim().toLowerCase();
  }


  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }

  clearInput(formControlName: string) {
    this.form.controls[formControlName].reset();
  }

  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }
  dialogCuentaDistribuidor(idTipo: number, c: CuentaDistribuidor) {

    let config: MatDialogConfig = new MatDialogConfig();
    config.width = '100%';
    config.height = 'auto';
    config.data = { c: c, idTipo: idTipo }
    let dialogRef = this.dialog.open(CuentasDistribuidoresDialogComponent, config);
    dialogRef.afterClosed().subscribe((data: number) => {
      if (data != 0) {
        this.buscarCuentaDistribuidor(idTipo);
      }
    })
  }

  buscarCuentaDistribuidor(idTipoMensaje: number) {
    this.cuentasService
      .cCuentasDistribuidores(this.c.idPais, this.c.idCompania, this.c.idSalesOrg, this.c.nroCliente)
      .subscribe((data: CuentaDistribuidor[]) => {
        this.dataSourceCuentasDistribuidores.data = [];
        if (data.length) {

          this.dataSourceCuentasDistribuidores.data = data;

          switch (idTipoMensaje) {
            case 1:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.AltaExitosa, 1, 1)
              break;
            case 2:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.ModificacionExitosa, 1, 1)
              break;
            case 3:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.EliminacionExitosa, 1, 1)
              break;

          }
        }

      })
  }

  dialogDireccion(idTipo: number, d: Direccion) {

    let config: MatDialogConfig = new MatDialogConfig();
    config.width = '100%';
    config.height = 'auto';
    config.data = { d: d, idTipo: idTipo }
    let dialogRef = this.dialog.open(DireccionesDialogComponent, config);
    dialogRef.afterClosed().subscribe((data: number) => {
      if (data != 0) {
        this.buscarDireccion(idTipo);
      }
    })
  }

  buscarDireccion(idTipoMensaje: number) {
    this.cuentasService
      .cDirecciones(this.c.idPais, this.c.idCompania, this.c.idSalesOrg, this.c.nroCliente)
      .subscribe((data: Direccion[]) => {
        this.dataSourceDirecciones.data = [];
        if (data.length) {

          this.dataSourceDirecciones.data = data;

          switch (idTipoMensaje) {
            case 1:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.AltaExitosa, 1, 1)
              break;
            case 2:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.ModificacionExitosa, 1, 1)
              break;
            case 3:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.EliminacionExitosa, 1, 1)
              break;

          }
        }

      })
  }

}
